import { Alert, Box, Button, Card, CardContent, CircularProgress, Container, Grid, IconButton, Snackbar, TextField, Typography } from '@mui/material'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import React, { useState } from 'react'
import { createPortifolio, deletePortifolio, fetchPortifolio, updatePortifolio } from './hooks/hooks';


import { useFormik } from 'formik';
import * as Yup from 'yup';
import { ArrowBack, Delete, Edit } from '@mui/icons-material';


// Validation Schema using Yup
const validationSchema = Yup.object({
    content: Yup.string()
      .required('Content is required')
      .min(50, 'Content must be at least 50 characters'),
  });
  // Validation Schema using Yup
const upValidationSchema = Yup.object({
    content: Yup.string()
      .required('Content is required')
      .min(50, 'Content must be at least 50 characters'),
  });
function Portifolio() {
    const queryClient = useQueryClient(); 
    const { data: portifolio, isLoading, isError, refetch } = useQuery({
       queryKey: ["portifolio"],
       queryFn: fetchPortifolio,
   });
   
       const [selectedItem, setSelectedItem] = useState(null);
       const [open, setOpen] = useState({ create: false, update: false});
       // const [formData, setFormData] = useState({ title: "", content: "", image: null });
       // const [formDataEdit, setFormDataEdit] = useState({ title: "", content: "", image: null  });
       const [toast, setToast] = useState({ open: false, message: "", severity: "" });
 
     // Update News Mutation
     const updateMutation = useMutation({
         mutationFn: updatePortifolio,
         onSuccess: () => {
             queryClient.invalidateQueries(["portifolioUpdate"]);
             // setFormDataEdit({ title: "", content: "", image: null });
             setOpen({ create: false, update: false, detail:false });
             setToast({ open: true, message: "Portifolio updated successfully!", severity: "success" });
         },
         onError: (error) => {
           setToast({ open: true, message: "Failed to update portifolio. Try again.", severity: "error" });
         }
     });
 
     // Delete News Mutation
     const deleteMutation = useMutation({
         mutationFn: deletePortifolio,
         onSuccess: () => {
             queryClient.invalidateQueries(["portifolioDelete"]);
             setToast({ open: true, message: "Portifolio deleted successfully!", severity: "success" });
         },
         onError: (error) => {
             setToast({ open: true, message: "Failed to delete Portifolio. Try again.", severity: "error" });
         }
     });
   
   const mutation = useMutation({
    mutationFn: createPortifolio, // Ensure `createNews` is a function
    onSuccess: (response) => {
      queryClient.invalidateQueries({ queryKey: ["newsPortifolio"] }); // Uncomment if needed
    //   setFormData({ title: "", content: "", image: null });
      setOpen({ create: false, update: false, detail:false });
      setToast({ open: true, message: "Portifolio added successfully!", severity: "success" });
       refetch()
    },
    onError: (error) => {
      setToast({ open: true, message: "Failed to add portifolio. Try again.", severity: "error" });
    }
  });

  const upformik = useFormik({
      initialValues: {
          content: '',
        },
        validationSchema: upValidationSchema,
        onSubmit: (values) => { 
          if (selectedItem.id) {
          updateMutation.mutate({ id: selectedItem.id, data: values });
        }
        },
      });

   const formik = useFormik({
    initialValues: {
        content: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
        mutation.mutate(values);
    },
    });

      // Open drawer and set form data when updating
  const handleOpenUpdateDrawer = (item) => {
    setSelectedItem(item);
    // Update formik values dynamically
    upformik.setValues({
        content: item.content || '',
    });
    setOpen({ create: false, update: true });
  };
 
  const toggleDrawer = (type, state) => () => {
    setOpen({ create: type === "create" ? state : false, update: type === "update" ? state : false });
   
  };

  // Handle delete
  const handleDelete = (id) => {
    deleteMutation.mutate(id);
};

   

   if (isLoading) {
    return (
        <Container sx={{ textAlign: "center", marginTop: 5 }}>
            <CircularProgress elevation={0} />
        </Container>
    );
}

if (isError) {
    return (
        <Container sx={{ textAlign: "center", marginTop: 5 }}>
            <Typography variant="h6" color="error">
                Error fetching portifolio. Please try again later.
            </Typography>
        </Container>
    );
}
  return (
    <Container>
        {portifolio?.length === 0 ? (
            <Container maxWidth="md">
            <Box
              sx={{
                mt: "4px",
                p: "4px",
                // borderRadius: 2,
                boxShadow: 0,
                backgroundColor: 'background.paper',
              }}
            >
              <Typography variant="h4" sx={{ fontWeight: 700, color: "#001f3f", fontSize:12, textTransform:"uppercase" }}>
                Add Company Portfolio
              </Typography>
              <Typography variant="body1" sx={{mb:2, color: "text.secondary", fontSize: 10, textTransform:"capitalize" }}>
                Highlight your company's expertise, projects, and achievements.
              </Typography>
              <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={3}>
                
                  {/* Content Field */}
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Content"
                      variant="outlined"
                      size="small"
                      multiline
                      rows={6}
                      name="content"
                      value={formik.values.content}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.content && Boolean(formik.errors.content)}
                      helperText={formik.touched.content && formik.errors.content}
                      InputLabelProps={{
                        sx: {
                          color: "#555", // Default label color
                          fontSize: 10,
                          transition: "color 0.3s ease",
                          "&:hover": {
                              color: "#333"
                          }, // Label color on hover
                          "&.Mui-focused": { 
                              color: "#001f3f",
                              textTransform:"uppercase",
                              fontWeight:500
                          }, // Label color on focus
                        },
                      }}
                      inputProps={{
                        sx: {
                          fontSize: 10, // Field content size
                          color: "#333", // Field content color
                          "&::placeholder": {
                            color: "#aaa", // Placeholder color
                            fontSize: 10,
                          },
                        },
                      }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: "2px",
                          "&.Mui-focused fieldset": { 
                              borderColor: "#001f3f",
                              borderRadius:"2px"
                          }, // Focus border
                        },
                        '& .MuiFormHelperText-root': {
                          fontSize: 9, // Smaller font size for validation errors
                          color: 'error.main', // Red color for errors
                          textTransform:"capitalize"
                        },
                      }}
                    />
                  </Grid>
      
                 
      
                  {/* Submit Button */}
                  <Grid item xs={12}>
                    <Button
                      type="submit"
                      variant="contained"
                      fullWidth
                      size="large"
                      sx={{
                        borderRadius: "2px",
                        textTransform: 'none',
                        py: 1.5,
                        fontSize: 10,
                        boxShadow:0,
                        backgroundColor:"#001f3f",                  
                        "&:hover": {
                            boxShadow: "none",
                        },
                      }}
                    >
                      Add New Portifolio
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Box>
          </Container>
        ):(
            open.update ? (
          <Container maxWidth="md">
            
            <IconButton
                onClick={toggleDrawer("update", false)}
            >
                <ArrowBack/>
            </IconButton>
            <Box
              sx={{
                mt: "4px",
                p: "4px",
                // borderRadius: 2,
                boxShadow: 0,
                backgroundColor: 'background.paper',
              }}
            >
              <Typography variant="h4" sx={{ fontWeight: 700, color: "#001f3f", fontSize:12, textTransform:"uppercase" }}>
                Update Company Portfolio
              </Typography>
              <Typography variant="body1" sx={{mb:2, color: "text.secondary", fontSize: 10, textTransform:"capitalize" }}>
                Highlight your company's expertise, projects, and achievements.
              </Typography>
              <form onSubmit={upformik.handleSubmit}>
                <Grid container spacing={3}>
                
                  {/* Content Field */}
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Content"
                      variant="outlined"
                      size="small"
                      multiline
                      rows={6}
                      name="content"
                      value={upformik.values.content}
                      onChange={upformik.handleChange}
                      onBlur={upformik.handleBlur}
                      error={upformik.touched.content && Boolean(upformik.errors.content)}
                      helperText={upformik.touched.content && upformik.errors.content}
                      InputLabelProps={{
                        sx: {
                          color: "#555", // Default label color
                          fontSize: 10,
                          transition: "color 0.3s ease",
                          "&:hover": {
                              color: "#333"
                          }, // Label color on hover
                          "&.Mui-focused": { 
                              color: "#001f3f",
                              textTransform:"uppercase",
                              fontWeight:500
                          }, // Label color on focus
                        },
                      }}
                      inputProps={{
                        sx: {
                          fontSize: 10, // Field content size
                          color: "#333", // Field content color
                          "&::placeholder": {
                            color: "#aaa", // Placeholder color
                            fontSize: 10,
                          },
                        },
                      }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: "2px",
                          "&.Mui-focused fieldset": { 
                              borderColor: "#001f3f",
                              borderRadius:"2px"
                          }, // Focus border
                        },
                        '& .MuiFormHelperText-root': {
                          fontSize: 9, // Smaller font size for validation errors
                          color: 'error.main', // Red color for errors
                          textTransform:"capitalize"
                        },
                      }}
                    />
                  </Grid>
      
                 
      
                  {/* Submit Button */}
                  <Grid item xs={12}>
                    <Button
                      type="submit"
                      variant="contained"
                      fullWidth
                      size="large"
                      sx={{
                        borderRadius: "2px",
                        textTransform: 'none',
                        py: 1.5,
                        fontSize: 10,
                        boxShadow:0,
                        backgroundColor:"#001f3f",                  
                        "&:hover": {
                            boxShadow: "none",
                        },
                      }}
                    >
                      Update Portifolio
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Box>
          </Container>
            ): (
                <Box>
                {portifolio?.map((item)=>(
                    <Container maxWidth='md'>
                        <Box>
                            <IconButton onClick={() => handleOpenUpdateDrawer(item)} color="inherit">
                                <Edit/> 
                            </IconButton>
                            <IconButton
                            color='error'
                            onClick={()=>handleDelete(item.id)} disabled={deleteMutation.isLoading}
                            >
                                <Delete/> 
                            </IconButton>
                        </Box>
                    <Grid item xs={12} sm={6} md={4} key={item.id}>
                        
                        <Card elevation={0} sx={{ height: "100%" }}>
                            <CardContent>
                                {/* <Typography variant="h6" gutterBottom>
                                {item.title}
                                </Typography> */}
                                <Typography 
                                    sx={{
                                        mb: 2,
                                        color: "text.secondary",
                                        fontSize: 10,
                                        textTransform: "capitalize",
                                        whiteSpace: "pre-line",
                                    }} 
                                    variant="body2" 
                                    color="text.secondary"
                                >
                                {item.content}
                                </Typography>
                                <Typography
                                    variant="caption"
                                    display="block"
                                    sx={{
                                        mt: 2,
                                        color: "#bcbcbc",
                                        fontSize: 9,
                                        fontWeight: 500,
                                    }}>
                                Published on: {new Date(item.published_at).toLocaleDateString()}
                                </Typography>
                            </CardContent>
                        </Card>
                  </Grid>
                  </Container>
                ))}
              
            </Box>
            )

            
        )}
        {/* Toast Notifications */}
        <Snackbar
        fullWidth
        open={toast.open}
        autoHideDuration={3000}
        onClose={() => setToast({ open: false, message: "", severity: "" })}
        >
        <Alert severity={toast.severity} 
        sx={{
                fontSize: 10, // Adjust font size
                fontWeight:500, // Make text bold
                width: "100%",
                borderRadius: "1px", // Rounded corners
                padding: "10px", // Adjust padding 
                textTransform:"capitalize"
            }}
        >
            {toast.message}
        </Alert>
        </Snackbar>
    </Container>
  )
}

export default Portifolio
